import Header from '@features/partner/components/Header';
import ProductsList from '@features/partner/components/ProductsList';
import Sidebar from '@features/partner/components/sidebar';
import ColorSwatchStyles from '@features/partner/components/ColorSwatchStyles';
import { useMediaQuery } from 'react-responsive';
import { Breakpoints } from '@settings';
import DesignsSlider from '@features/partner/components/sidebar/DesignsSlider';

const PartnerPage = () => {
  const isMobile = useMediaQuery({ maxWidth: Breakpoints.MD });

  return (
    <div className='page-design tw-mx-auto tw-min-h-screen tw-max-w-[1952px]'>
      <ColorSwatchStyles />

      <Header />

      <div className='tw-mx-auto tw-flex tw-max-w-[1480px] tw-flex-col tw-justify-between tw-gap-4 tw-px-5 md:tw-flex-row'>
        <div className='tw-w-full md:tw-w-4/12 lg:tw-w-3/12'>{!isMobile && <Sidebar rel='nofollow' />}</div>
        <div className='tw-relative tw-w-full md:tw-w-[calc(66%-16px)] lg:tw-w-[calc(75%-16px)]'>
          {isMobile && <DesignsSlider />}
          <ProductsList rel='nofollow' />
        </div>
      </div>
    </div>
  );
};

export default PartnerPage;
